import { jsxs as C, jsx as L } from "react/jsx-runtime";
const s = () => /* @__PURE__ */ C("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 800 277", fill: "none", children: [
  /* @__PURE__ */ L(
    "path",
    {
      d: "M647.99 0H645.168C633.533 0 625.271 6.21898 621.875 17.3489L582.542 146.226H585.25C596.884 146.226 605.215 139.939 608.611 128.809L647.99 0Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M608.152 0H603.609C591.974 0 583.758 6.24193 580.362 17.3489L540.983 146.204H545.435C557.07 146.204 565.4 139.916 568.796 128.786L608.152 0Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M523.244 0H515.12C503.485 0 495.155 6.21898 491.759 17.3489L452.425 146.226H460.618C472.253 146.226 480.514 139.939 483.91 128.809L523.244 0Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M566.593 0H560.351C548.716 0 540.432 6.24193 537.035 17.3489L497.725 146.204H503.875C515.51 146.204 523.84 139.916 527.237 128.786L566.593 0Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M108.293 0C93.8812 0 81.1449 9.40879 76.9454 23.2007L66.2744 58.128C61.6618 73.1821 72.9294 88.3968 88.672 88.3968H182.645C183.425 88.3968 183.976 89.1541 183.747 89.8884L176.954 112.125C176.747 112.814 176.128 113.273 175.416 113.273H83.0955C68.5693 113.273 55.7641 122.75 51.5187 136.634L48.5813 146.226H171.538H175.233H180.052C191.595 146.226 201.761 138.699 205.134 127.661L217.274 88.0984C221.887 73.0444 210.619 57.8297 194.877 57.8297H100.88C100.1 57.8297 99.5494 57.0724 99.7789 56.338L106.572 34.1011C106.778 33.4127 107.398 32.9537 108.109 32.9537H197.699C212.203 32.9537 225.031 23.4761 229.276 9.59238L232.03 0H108.293Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M284.949 0C270.537 0 257.801 9.40879 253.601 23.2007L227.004 110.198C221.519 128.097 234.921 146.204 253.647 146.204H356.731C368.274 146.204 378.44 138.676 381.813 127.638L383.167 123.232C383.19 123.14 383.236 123.072 383.259 123.003L387.436 109.371L392.691 92.2062C392.737 92.0226 392.783 91.839 392.851 91.6554L393.953 88.0755C398.565 73.0214 387.298 57.8067 371.555 57.8067H331.327H296.583C295.413 74.6278 310.582 88.3968 327.472 88.3968H359.324C360.104 88.3968 360.655 89.1541 360.425 89.8884L353.633 112.125C353.472 112.63 353.082 113.02 352.6 113.181C352.439 113.227 352.279 113.273 352.095 113.273H331.327H260.577C259.797 113.273 259.246 112.515 259.476 111.781L283.227 34.1011C283.434 33.4127 284.054 32.9537 284.765 32.9537H374.516C388.927 32.9537 401.664 23.5449 405.863 9.75302L408.846 0H284.949Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M478.082 0H463.418C449.144 0 436.545 9.38585 432.369 23.0401L394.71 146.226H413.895C425.438 146.226 435.719 138.585 439.092 127.547L478.082 0Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M706.004 226.523C711.649 226.591 715.114 228.703 722.297 232.535C729.847 236.574 737.122 239.534 737.122 239.534L739.325 223.218L800 180.603L791.509 176.082C788.021 174.223 787.057 169.794 789.237 165.687L799.082 147.282L779.37 152.629C774.986 153.822 771.039 151.757 770.144 147.833L767.964 138.263L743.249 160.89L766.84 101.363L757.087 106.549C745.452 112.745 733.312 107.077 733.083 95.3501L732.578 69.0055L720.874 95.3501C715.665 107.077 701.116 112.745 692.12 106.549L684.57 101.363L682.849 160.89L667.749 138.263L661.484 147.856C658.914 151.803 654.095 153.845 650.217 152.652L632.776 147.305L634.795 165.71C635.231 169.794 632.386 174.246 628.117 176.105L617.699 180.626L660.268 223.241L655.541 239.557C655.541 239.557 664.077 236.574 673.348 232.558C682.161 228.726 686.521 226.614 692.189 226.545L683.951 265.351H3.3275L0 276.274H695.448L706.004 226.523Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M427.458 164.424L402.238 246.946H420.849L440.401 183.035H492.86C496.119 183.035 498.46 186.202 497.519 189.323L486.986 223.769C486.137 226.522 483.612 228.381 480.744 228.381H433.31L427.618 246.992H484.783C492.929 246.992 500.112 241.668 502.476 233.889L516.405 188.359C520.031 176.472 511.15 164.447 498.712 164.447H427.458V164.424Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M320.312 164.424H318.5C308.517 164.424 299.728 170.942 296.813 180.488L285.316 218.078L256.815 164.424H233.706L208.485 246.924H213.396C221.543 246.924 228.726 241.6 231.09 233.82L245.088 188.038L276.412 246.969L295.115 246.924L320.312 164.424Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M201.831 164.424H168.9C162.451 164.424 156.462 167.775 153.111 173.282L108.11 246.969H120.571C127.019 246.969 133.009 243.619 136.359 238.111L166.605 188.566C168.716 185.124 172.457 183.013 176.496 183.013H182.852L182.829 228.358H166.146C157.999 228.358 150.816 233.682 148.453 241.462L146.778 246.969H201.808L201.831 164.424Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M395.606 164.424H362.675C356.226 164.424 350.237 167.775 346.886 173.282L301.885 246.969H311.982C319.876 246.969 327.22 242.862 331.351 236.115L360.38 188.589C362.491 185.147 366.232 183.035 370.271 183.035H376.627L376.605 228.381H359.921C351.774 228.381 344.592 233.705 342.228 241.485L340.553 246.992H395.583L395.606 164.424Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M596.128 164.424H563.197C556.748 164.424 550.759 167.775 547.408 173.282L502.407 246.969H512.504C520.398 246.969 527.742 242.862 531.872 236.115L560.902 188.589C563.013 185.147 566.754 183.035 570.793 183.035H577.149L577.126 228.381H560.443C552.296 228.381 545.113 233.705 542.75 241.485L541.075 246.992H596.105L596.128 164.424Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M32.7244 228.358L46.5851 183.035H103.749C111.896 183.035 119.079 177.711 121.442 169.932L123.118 164.424H47.3654C39.2187 164.424 32.0359 169.748 29.6722 177.528L14.6641 226.614C11.566 236.734 19.139 246.946 29.7181 246.946H90.99C99.1367 246.946 106.319 241.622 108.683 233.843L110.358 228.335H32.7244V228.358Z",
      className: "cls-1"
    }
  )
] });
export {
  s as SgiCanadaLogoSvg
};
